export const MANUAL_KYC_STATUSES = [
  "none",
  "pending",
  "approved",
  "rejected",
  "expired",
  "requiresReview",
] as const;

export type ManualKycStatus = (typeof MANUAL_KYC_STATUSES)[number];
